// prettier-ignore

export default {
  "home": {
    "connect-wallet": "CONNECT WALLET",
    "welcome-text": "${{qbxCurrency}} Public Community Sale",
    "welcome-desc": "Participate in the ${{qbxCurrency}} sale and join qiibee's ecosystem to benefit from millions of real world rewards.",
    "hours": "Hours",
    "mins": "Mins",
    "seconds": "Seconds",
    "your-deposit": "Your Deposit",
    "price": "Price",
    "bought": "Bought",
    "pre-sale-raffle-tickets": "Pre-Sale Raffle Tickets",
    "public-sale-raffle-tickets": "Public-Sale Raffle Tickets",
    "allocations": "Allocation(s)",
    "allocations-from-nfts": "Allocation(s) from NFTs held",
    "pre-sale-help": "Pre-sale allocations are given based on the amount of QBX Founders Key held in the connected wallet.",
    "deposit-points-earned": "Deposit Points Earned",
    "deposit-points-help-text": "For every $1 worth of deposit that you make, you earn 10 Deposit Points. Check the Points Bonuses to see the various multipliers and bonuses you can get.",
    "deposit-points-desc": "You can double your Deposit Points and earn another <strong>{{value}}</strong> points if you post about your ${{qbxCurrency}} sale participation on your X account! Try it out now!",
    "total-deposit-points-earned": "Total Deposit Points Earned",
    "total-deposit-points-help-text": "This is the final amount of Deposit Points you earned from deposits, multipliers, and bonuses, including the community bonus.",
    "tickets": "Tickets",
    "deposit-status": "${{qbxCurrency}} Sale Deposit Progress",
    "deposit-status-desc": "You can keep depositing and get more tickets even after we reach 100%, to increase your chances of winning a bigger {{qbxCurrency}} allocation, earn more Deposit Points, and increase the overall rewards pool!",
    "deposit": "Deposit",
    "deposit-desc": "Enter the amount of {{ethCurrency}} you want to deposit. There is no minimum or maximum deposit, you can keep depositing until the end of the token sale to get as many tickets as you want, and increase the chances of winning the raffle. You will also earn Deposit Points for every deposit you make!",
    "deposit-amount": "Deposit Amount",
    "deposited-title": "Awesome! You successfully deposited {{ethCurrency}}!",
    "deposited-desc": "Thank you for participating in the ${{qbxCurrency}} Public Community Sale! Your {{ethCurrency}} deposit was successful! Additionally to getting raffle tickets, you also earn Deposit Points!",
    "you-can-earn-deposit-points": "You can earn another <strong>{{value}}</strong> Deposit Points if you post about your ${{qbxCurrency}} sale participation on your X account! Try it out now!",
    "share-post": "Share post",
    "something-went-wrong": "Something went wrong, please try again.",
    "rejected-transaction-request": "You have rejected the transaction request.",
    "transaction-processing": "Your transaction is being processed. Please wait a moment.",
    "refunded-title": "Withdrawn {{ethCurrency}}",
    "refunded-desc": "You have been successfully withdrawn the following amount of {{ethCurrency}}.",
    "refunded-info": "You have been successfully withdrawn <strong>{{value}}</strong>.",
    "sale-ended": "Unfortunately, the sale has ended, and we are no longer accepting deposits at this time.",
    "home": "Home",
    "leaderboard": "Leaderboard",
    "terms-and-conditions": "Terms of QBX Public Community Token Sale",
    "privacy-policy": "Privacy Policy",
    "faqs": "FAQs",
    "copy-right-text": "qiibee foundation - All Rights Reserved",
    "privacy-policy-desc": "By depositing ETH and therefore participating in the QBX Public Community Sale, you agree to the <0>terms</0> and the <1>privacy policy</>.",
    "wallet-balance": "Wallet balance: {{value}} {{symbol}}",
    "required-field": "This field is required.",
    "invalid-number-format": "Please enter a correct number.",
    "you-successfully-connected": "You have successfully connected QBX VIP Club account.",
    "claimed-title": "Redeemed Deposit Points",
    "claimed-desc": "You have successfully redeemed the following amount of Deposit Points.",
    "points-bonuses": "Points Bonuses",
    "enter-the-ultimate-rewards": "Enter the ultimate rewards ecosystem!",
    "connect-your-wallet": "Connect your wallet",
    "deposit-for-allocation": "Deposit {{ethCurrency}} for {{qbxCurrency}} allocation tickets",
    "more-tickets": "More tickets = higher chance to win the raffle",
    "most-recent-deposits": "Most recent deposits",
    "worth-value": "(worth {{value}} {{qbxCurrency}})",
    "points-bonuses-desc": "Earn Deposit points for every deposit you make, even if you don't win your ${{qbxCurrency}} allocation in the community sale raffle! Below you see the bonuses you can get.",
    "deposit-points-earned-per": "Deposit points earned per $1 deposited",
    "your-current-total-multiplier": "Your current total multiplier",
    "check-out-leaderboards": "Check out Leaderboards",
    "time-based-multipliers": "Time Based Multipliers",
    "founders-key-multipliers": "QBX Founders Key Multipliers",
    "deposit-in-the-first": "Deposit in the first {{minutes}}-minutes",
    "deposit-in-the-last": "Deposit in the last 180-minutes",
    "deposit-after-the-first": "Deposit after the first 120-minutes",
    "you-hold-qbx-founders-key": "You hold QBX Founders Key ≥ {{value}}",
    "time-based-deposit-bonuses": "Time Based Deposit Bonuses",
    "wallet-to-deposit": "{{position}} wallet to deposit",
    "last-wallet-to-deposit": "Last wallet to deposit",
    "wallet-can-only-win-once": "A wallet can only win once.",
    "amount-based-deposit-bonuses": "Amount Based Deposit Bonuses",
    "first-wallet-to-deposit": "First wallet to deposit {{value}}",
    "wallet-to-deposit-largest-amount": "Wallet to deposit largest amount",
    "to-win-these-bonuses": "To win these bonuses, the deposit amounts mentioned above need be made at once to win, not cumulative.",
    "pre-pub-value": "Nr. of Pre-Sale Raffle Tickets you will get: <strong>{{preValue}}</strong> <br /> Nr. of Public-Sale Raffle Tickets you will get: <strong>{{pubValue}}</strong>",
    "referral-bonuses": "Referral Bonuses",
    "first-to-refer": "First to refer {{value}}",
    "most-referred-wallets": "Most referred wallets",
    "individual-leaderboard-bonuses": "Individual Leaderboard Bonuses",
    "place": "{{value}} place",
    "from-to-place": "{{from}} to {{to}} place",
    "click-the-button-to-leaderboards": "Click the button below to go to the leaderboards.",
    "it-takes-time-refresh": "It takes a couple of min. to show the Deposit Points.",
    "multiplier-active-for": "Hurry! The \"Last {{value}}-minutes\" {{points}}x Pts. <br />multiplier is still active for: <0></0>",
    "wallets-only-count": "Wallet only count as referred if they deposited at least enough for 1 Public-Sale raffle ticket, and if a person used multiple referral links, only the first one counts.",
    "top-communities-deposit-bonuses": "Top 10 Communities Deposit Bonuses",
    "place-community": "{{position}} place community",
    "per-community-wallet": "{{points}} per community wallet",
    "sale-note": "If you deposit more than $5'000 worth of ETH you enter an exclusive raffle to win points from an additional reward pool worth $100'000."
  },
  "staking": {
    "redeem-points": "Redeem points",
    "up-to": "up to",
    "connect": "Connect",
    "connect-account-claim": "Redeem Deposit Points",
    "connect-account-claim-desc": "Connect your <0>QBX VIP Club account</0> to redeem your Deposit Points.",
    "invalid-account-number": "Please enter a correct account number.",
    "vip-club-account-number": "QBX VIP Club account number"
  },
  "referral": {
    "referral-title": "Refer friends and earn Deposit Points",
    "referral-help-text": "A friend only counts as referred if they bought at least 1 public sale ticket.",
    "referral-desc": "You can earn even more Deposit Points by referring your friends, and earning {{value}}% of the Deposit Points they have earned! Invite them by sharing your unique referral link!",
    "copy-referral-link": "Copy referral link",
    "friends-referred": "Friends referred",
    "points-earned": "Points earned",
    "referral-link-copied": "Your referral link was successfully copied to the clipboard."
  },
  "leaderboard": {
    "title": "$QBX Public Community Sale Leaderboard",
    "description": "Check out the ranking of the top individuals and communities who participate in the qiibee Community Sale.",
    "your-ranking": "Your ranking",
    "top-ranking": "Top 100 ranking",
    "wallet": "Wallet",
    "deposit": "Deposit",
    "time": "Time",
    "deposit-points": "Deposit points",
    "community": "Community",
    "communities-ranking": "Communities ranking",
    "your-community": "Your community",
    "ranking-of-your-community": "Ranking of your community"
  },
  "results": {
    "title": "Congratulations! These are your results.",
    "description": "Thank you for participating in our community sale.",
    "pre-sale-participation": "Pre-Sale Participation",
    "public-sale-participation": "Public-Sale Participation",
    "ticket-price": "Ticket Price",
    "tickets-bought": "Tickets Bought",
    "tickets-won": "Tickets Won",
    "qbx-received": "$QBX Received",
    "refund-amount": "Withdrawal Amount",
    "refund": "Withdraw",
    "go-to-claim-page": "Go To QBX Claim Page",
    "thank-you-for-participating": "Thank you for participating! We are running the raffle and the winners will be announced in approximately {{time}}h!",
    "the-wait-is-over": "The wait is over! Thank you for participating! Check the raffle results to see if you won!",
    "thank-you-for-participating-refund-funds": "Thank you for participating! You can now withdraw the amount {{ethCurrency}} from the tickets that didn't win. As well as redeem your deposit points!",
    "view-results": "View Results",
    "deposit-points-received": "Deposit Points Bonuses Received",
    "deposit-points-received-help": "Here you can see if you hit any bonuses milestone and the bonus Deposit Points you received from them.",
    "time-based": "Time based",
    "points-wallet-to-deposit": "({{position}} wallet to deposit)",
    "amount-based": "Amount based",
    "first-wallet-to-deposit": "(First wallet to deposit {{position}})",
    "referral-bonus": "Referral bonus",
    "referral-first-wallet": "({{label}})",
    "not-first-wallet": "Not the first to refer wallets",
    "referred-wallets": "{{position}} referred",
    "individual-ranking-bonus": "Individual ranking bonus",
    "place-ranking": "({{position}} place ranking)",
    "community-ranking-bonus": "Community ranking bonus",
    "place-community": "({{position}} place community)"
  },
  "intro": {
    "introduction-about-us": "Introduction about us",
    "what-is-qb": "About qiibee",
    "description": "qiibee is the decentralized payment infrastructure for the $500bn rewards economy.<br /> <br />Our vision is to make loyalty currencies one of the top 3 global payment methods. <br /> <br /> We offers a decentralized payment infrastructure, powered by $QBX, that enables businesses and consumers to enrich their loyalty currencies with more liquidity by trade their points to over 10M real world rewards, gift cards and miles from brand such as Miles & More from Lufthansa, Etihad Guest, Apple, Adidas, Amazon, as well as crypto directly on your Binance or Coinbase account.<br /> <br />Join us in shaping the future of the rewards economy!",
    "stats": {
      "loyalty_wallets": "Loyalty Wallets on QRC",
      "loyalty_transactions": "Loyalty Transactions on QRC",
      "value_transacted": "Value Transacted on QRC",
      "mini_app": "SocialFi & TON mini-app users",
      "wallets_connected": "Wallets connected",
      "raised": "Raised in Oversubscribed Private Sale"
    },
    "strategic-partners": "Strategic partners",
    "amplifying-ecosystem": "Amplifying qiibee's Ecosystem",
    "key-stats": "Key stats about qiibee"
  },
  "common": {
    "cancel": "Cancel",
    "close": "Close"
  },
  "notification": {
    "bonus-unlocked": "Bonus unlocked! Congrats!",
    "you-received-bonus": "You received a bonus of {{points}} for being the {{message}}!"
  }
}
